import { SectionShell, Note } from "@/components/dash/primitives";
import { Ship, Anchor } from "lucide-react";

export default function Capacity({ data, num, title }) {
  const icons = [Ship, Anchor];
  return (
    <SectionShell id="capacity" num={num} title={title}>
      <p className="text-slate-700 leading-relaxed max-w-4xl mb-10">{data.intro}</p>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {data.services.map((s, i) => {
          const Icon = icons[i % icons.length];
          return (
            <div
              key={i}
              data-testid={`capacity-service-${i}`}
              className="relative bg-white border border-slate-200 rounded-xl p-7 overflow-hidden transition-all duration-300 hover:shadow-lg hover:-translate-y-1 hover:border-slate-300"
            >
              <div className="absolute top-0 left-0 w-1 h-full bg-accent" />
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Icon className="w-5 h-5 text-primary" />
                </div>
                <span className="font-num text-xs uppercase tracking-wider text-accent font-semibold">{s.tag}</span>
              </div>
              <h3 className="font-display text-xl font-semibold text-slate-900 leading-tight">{s.title}</h3>
              <p className="text-sm text-slate-600 mt-3 leading-relaxed">{s.desc}</p>
            </div>
          );
        })}
      </div>
      <Note accent>{data.outro}</Note>
    </SectionShell>
  );
}
